import { StudentClassResult } from "../../models/Analytics/class.model";
import { SET_ANALYTICS_DATA } from "../definitions/analyticsConstants";

export const setAnalyticsData = (data: StudentClassResult) => {
    return {
        type: SET_ANALYTICS_DATA,
        payload: data
    }
}